export const CART_TYPE = "modal" || "drawer";

export const ANIMATION_LOAD = "true" === "true";
export const ANIMATION_INTERVAL =
  "default" === "default" ? 0 : 0.05;
// fade_up, fade_down, fade_in
export const ANIMATION_INTERVAL_STYLE =
  "fade_up" || "fade_up";
// Kunstiek 27-10-2026: duur (ms) en afstand (px) uit Thema-instellingen > Kunstiek
export const ANIMATION_DURATION =
  Number("1800") / 1000 || 1;
export const ANIMATION_DISPLACEMENT =
  Number("80") || 0;
